import { z } from 'zod'
import { ASSIGNABLE_ROLES, USER_ROLES } from '../permissions'

/**
 * Email validation for EdenData domain.
 */
const edenDataEmailSchema = z
  .string()
  .email('Invalid email format')
  .refine((email) => email.endsWith('@edendata.com'), {
    message: 'Email must be an @edendata.com address',
  })

/**
 * Schema for creating a new user.
 * - email: required, must be @edendata.com
 * - role: required, must be an assignable role (not owner)
 */
export const createUserSchema = z.object({
  email: edenDataEmailSchema,
  role: z.enum(ASSIGNABLE_ROLES, {
    message: 'Role must be admin, manager, or basic_user',
  }),
})

export type CreateUserInput = z.infer<typeof createUserSchema>

/**
 * Schema for updating a user's role.
 * - role: required, must be an assignable role (not owner)
 * - reason: optional audit note
 */
export const updateUserRoleSchema = z.object({
  role: z.enum(ASSIGNABLE_ROLES, {
    message: 'Role must be admin, manager, or basic_user',
  }),
  reason: z.string().max(500, 'Reason must be 500 characters or less').optional(),
})

export type UpdateUserRoleInput = z.infer<typeof updateUserRoleSchema>

/**
 * Schema for validating a user role (including owner for reading).
 */
export const userRoleSchema = z.enum(USER_ROLES, {
  message: 'Invalid role',
})

export type UserRoleInput = z.infer<typeof userRoleSchema>
